// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index__code--R2GUF{padding:.2em .4em;margin:0;font-size:85%;white-space:break-spaces;background-color:rgba(101,108,118,.2);border-radius:6px}.index__image--bLUji{max-width:100%;height:auto}.index__video--dDvoP{max-width:100%;height:auto}`, "",{"version":3,"sources":["webpack://./src/Components/WrapMarkdown/index.scss"],"names":[],"mappings":"AAAA,oBAMI,iBAAA,CACA,QAAA,CACA,aAAA,CACA,wBAAA,CACA,qCAAA,CACA,iBAAA,CAGJ,qBACI,cAAA,CACA,WAAA,CAGJ,qBACI,cAAA,CACA,WAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"code": `index__code--R2GUF`,
	"image": `index__image--bLUji`,
	"video": `index__video--dDvoP`
};
export default ___CSS_LOADER_EXPORT___;
